const Loading = () => 'loading...';

export default Loading;
